/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_2_AnswerInputs */

const en_svc_n8n_faq_2_answer = /** @type {(inputs: Svc_N8n_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosting gives more control over data, and over cost at volume; n8n Cloud means less to maintain. We recommend one based on your data, team and budget, and can set up either.`)
};

const lv_svc_n8n_faq_2_answer = /** @type {(inputs: Svc_N8n_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pašu mitināšana dod lielāku kontroli pār datiem un izmaksām pie lieliem apjomiem; n8n Cloud nozīmē mazāk uzturēšanas. Iesakām variantu pēc Jūsu datiem, komandas un budžeta, un varam uzstādīt jebkuru.`)
};

/**
* | output |
* | --- |
* | "Self-hosting gives more control over data, and over cost at volume; n8n Cloud means less to maintain. We recommend one based on your data, team and budget, a..." |
*
* @param {Svc_N8n_Faq_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_2_answer = /** @type {((inputs?: Svc_N8n_Faq_2_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_2_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_2_answer(inputs)
	return en_svc_n8n_faq_2_answer(inputs)
});